import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIsDesktop } from "@/hooks/useBreakpoint";
import { useGetListagemEmpresas } from "@/queries/useEmpresas";
import { useGetListagemMunicipios } from "@/queries/useMunicipios";
import { useGetMapaRotas } from "@/queries/useRotas";
import { defaultCoordinates, empresasToSelectItems } from "@/utils";
import { useState } from "react";
import { BackButtonTitle } from "../BackButtonTitle";
import { MapaDeRotas } from "../RouteMap";
import { RouteDetailsDialog } from "../RouteMap/dialog";
import { FilterRoutes } from "../RouteMap/filter-card";
export default function MainPage() {
    const [selectedRoute, setSelectedRoute] = useState(null);
    const [filters, setFilters] = useState({});
    const isDesktop = useIsDesktop();
    const { data: routesData } = useGetMapaRotas(filters.municipioPartida, filters.municipioDestino, filters.empresa, filters.diaSemana);
    const { data: municipiosData } = useGetListagemMunicipios();
    const { data: empresasData } = useGetListagemEmpresas();
    const routes = routesData?.content;
    const municipioById = new Map();
    municipiosData?.forEach((entry) => {
        municipioById.set(entry.municipioPartida.id, entry.municipioPartida.municipio);
        entry.municipiosDestinos.forEach((dest) => {
            municipioById.set(dest.id, dest.municipio);
        });
    });
    const empresas = empresasToSelectItems(empresasData ?? []);
    function onApplyFilters(filters) {
        setFilters({
            empresa: filters.empresa,
            municipioPartida: filters.municipioPartida
                ? municipioById.get(Number(filters.municipioPartida))
                : undefined,
            municipioDestino: filters.municipioDestino
                ? municipioById.get(Number(filters.municipioDestino))
                : undefined,
            diaSemana: filters.diaSemana,
        });
    }
    function onClearFilters() {
        setFilters({});
    }
    return (_jsx("div", { className: "max-w-5xl mx-auto px-4", children: _jsxs("div", { className: "my-8 h-full", children: [_jsx(BackButtonTitle, { title: "Mapa de Rotas" }), _jsxs("div", { className: isDesktop
                        ? "grid w-full grid-cols-[400px_1fr] gap-6"
                        : "flex flex-col gap-6", children: [_jsx(RouteDetailsDialog, { selectedRoute: selectedRoute, onSelectRoute: setSelectedRoute }), _jsx(FilterRoutes, { municipiosData: municipiosData, empresas: empresas, routes: routes ?? [], selectedRoute: selectedRoute, onSelectRoute: setSelectedRoute, onApplyFilters: onApplyFilters, onClearFilters: onClearFilters }), isDesktop && (_jsx(MapaDeRotas, { routes: routes ?? [], selectedRoute: selectedRoute, onSelectRoute: setSelectedRoute, mapCenterCoordinates: defaultCoordinates, zoom: 5 }))] })] }) }));
}
